import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useToggleFavoriteBenefit } from '../../hooks/useToggleFavoriteBenefit';
import { actions as membershipBenefitSearchActions } from '../../redux/modules/membershipBenefitSearch';
import { MembershipBenefitReference } from '../../../../types/membershipBenefitReferenceType';
import { Benefit } from './CardBenefitPartner.types';

export const useCardBenefitFavorite = (
  benefit: Benefit,
  disableFavorite: boolean,
  onFavoriteChange?: (isFavorite: boolean) => void,
) => {
  const { id, slug, title, name, isLocalContent, isFavorite } = benefit;
  const dispatch = useDispatch();
  const canFavorite = !!id && !isLocalContent && !disableFavorite;

  const handleFavoriteChange = useCallback(
    (nextIsFavorite: boolean) => {
      if (nextIsFavorite) {
        dispatch(membershipBenefitSearchActions.addFavoriteBenefit({ benefit: benefit as MembershipBenefitReference }));
      } else {
        dispatch(membershipBenefitSearchActions.removeFavoriteBenefit({ id }));
      }
      onFavoriteChange?.(nextIsFavorite);
    },
    [dispatch, benefit, id, onFavoriteChange],
  );

  const { isFavorite: isFavorited, toggleFavorite } = useToggleFavoriteBenefit(
    canFavorite ? id : undefined,
    canFavorite ? slug : undefined,
    isFavorite,
    canFavorite ? handleFavoriteChange : onFavoriteChange,
    title || name,
  );

  return { canFavorite, isFavorited, toggleFavorite };
};
